import {
  Input,
  FormField,
  SpaceBetween,
  Container,
  DatePicker,
  Select,
  Textarea,
  Tiles,
  Box,
  Link,
  ColumnLayout,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";

export const FormBlock1 = (props: any) => {
  return (
    <SpaceBetween direction="vertical" size="l">
      <ColumnLayout columns={2}>
        <FormField
          label={
            <SpaceBetween direction="horizontal" size="xs">
              <Box variant="strong">{LABELS.APPLICABLE_START_DATE}</Box>
              <Box variant="small" color="text-status-error">
                {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
              </Box>
            </SpaceBetween>
          }
          errorText={props.applicationStartDateErrorMsg}
        >
          <DatePicker
            onChange={({ detail }) =>
              props.onChangeApplicationStartDate(detail.value)
            }
            value={props.applicationStartDate}
            openCalendarAriaLabel={(selectedDate) =>
              "Choose certificate expiry date" +
              (selectedDate ? `, selected date is ${selectedDate}` : "")
            }
            nextMonthAriaLabel="Next month"
            placeholder="YYYY/MM/DD"
            previousMonthAriaLabel="Previous month"
            todayAriaLabel="Today"
            readOnly={props.readOnly}
          />
        </FormField>
        <Box float="right">
          {props.commercialData && (
            <Link onFollow={props.onClickCommercialApplicationInfo}>
              {LABELS.SHOW_COMMERCIAL_APPLICATION_INFO}
            </Link>
          )}
        </Box>
      </ColumnLayout>

      <SpaceBetween direction="horizontal" size="l">
        <FormField label={LABELS.TYPE_NO}>
          <Input
            onChange={({ detail }) => props.setTypeNo(detail.value)}
            value={props.typeNo}
            readOnly
          />
        </FormField>
      </SpaceBetween>
      <FormField
        label={
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="strong">{LABELS.TYPE_NAME}</Box>
            <Box variant="small" color="text-status-error">
              {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
            </Box>
          </SpaceBetween>
        }
        stretch={true}
        constraintText="100文字以内"
        errorText={props.typeNameErrorMsg}
      >
        <ColumnLayout columns={2}>
          <Input
            onChange={({ detail }) => props.onChangeTypeName(detail.value)}
            value={props.typeName}
            readOnly={props.readOnly}
          />
        </ColumnLayout>
      </FormField>
      <FormField
        label={
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="strong">{LABELS.ADDRESS_MANAGEMENT}</Box>
            <Box variant="small" color="text-status-error">
              {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
            </Box>
          </SpaceBetween>
        }
      >
        {props.readOnly ? (
          <Tiles
            value={props.addressManagementRequiredFlag}
            items={props.necessaryItems}
            columns={2}
          ></Tiles>
        ) : (
          <Tiles
            onChange={({ detail }) =>
              props.onChangeAddressManagement(detail.value)
            }
            items={props.necessaryItems}
            value={props.addressManagementRequiredFlag}
            columns={2}
          ></Tiles>
        )}
      </FormField>
    </SpaceBetween>
  );
};

export const FormBlock2 = (props: any) => {
  return (
    <SpaceBetween direction="vertical" size="l">
      <FormField
        label={
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="strong">{LABELS.STORE_INFO_AGGREGATION_TARGET}</Box>
            <Box variant="small" color="text-status-error">
              {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
            </Box>
          </SpaceBetween>
        }
      >
        {props.readOnly ? (
          <Tiles
            value={props.storeInfoAggregationTargetFlag}
            items={props.storeInfoAggregationTargetItems}
            columns={2}
          ></Tiles>
        ) : (
          <Tiles
            onChange={({ detail }) => {
              props.setStoreInfoAggregationTargetFlag(detail.value);
              props.setChangeFlag(true);
            }}
            items={props.storeInfoAggregationTargetItems}
            value={props.storeInfoAggregationTargetFlag}
            columns={2}
          ></Tiles>
        )}
      </FormField>
      <FormField
        label={
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="strong">{LABELS.FAKE_INDUSTRY_CHECK}</Box>
            <Box variant="small" color="text-status-error">
              {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
            </Box>
          </SpaceBetween>
        }
      >
        {props.readOnly ? (
          <Tiles
            value={props.fakeIndustryCheckRequiredFlag}
            items={props.necessaryItems}
            columns={2}
          ></Tiles>
        ) : (
          <Tiles
            onChange={({ detail }) => {
              props.setFakeIndustryCheckRequiredFlag(detail.value);
              props.setChangeFlag(true);
            }}
            items={props.necessaryItems}
            value={props.fakeIndustryCheckRequiredFlag}
            columns={2}
          ></Tiles>
        )}
      </FormField>
      <SpaceBetween direction="horizontal" size="l">
        <FormField
          label={
            <SpaceBetween direction="horizontal" size="xs">
              <Box variant="strong">{LABELS.STORE_APPLICATION_FORM}</Box>
              <Box variant="small" color="text-status-error">
                {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
              </Box>
            </SpaceBetween>
          }
          errorText={props.storeApplicationFormErrorMsg}
        >
          {props.readOnly ? (
            <Select
              selectedOption={props.storeApplicationFormKbn}
              onChange={() => {}}
            />
          ) : (
            <Select
              selectedOption={props.storeApplicationFormKbn}
              onChange={({ detail }) =>
                props.onChangeStoreApplicationForm(detail.selectedOption)
              }
              options={props.storeApplicationFormItems}
              selectedAriaLabel="Selected"
            />
          )}
        </FormField>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export const FormBlock3 = (props: any) => {
  return (
    <SpaceBetween direction="vertical" size="l">
      <FormField
        label={
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="strong">{LABELS.TENANT_EXAMINATION}</Box>
            <Box variant="small" color="text-status-error">
              {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
            </Box>
          </SpaceBetween>
        }
      >
        {props.readOnly ? (
          <Tiles
            value={props.tenantExaminationRequiredFlag}
            items={props.necessaryItems}
            columns={2}
          ></Tiles>
        ) : (
          <Tiles
            onChange={({ detail }) =>
              props.setTenantExaminationRequiredFlag(detail.value)
            }
            items={props.necessaryItems}
            value={props.tenantExaminationRequiredFlag}
            columns={2}
          ></Tiles>
        )}
      </FormField>
      <SpaceBetween direction="horizontal" size="xs">
        <FormField
          label={
            <SpaceBetween direction="horizontal" size="xs">
              <Box variant="strong">{LABELS.TENANT_EXAMINATION_UNIT}</Box>
              <Box variant="small" color="text-status-error">
                {LABELS.TENANT_EXAMINATION_UNIT_ITEM_MESSAGE}
              </Box>
            </SpaceBetween>
          }
          errorText={props.tenantExaminationUnitErrorMsg}
        >
          {props.readOnly ? (
            <Select
              selectedOption={props.tenantExaminationUnitKbn}
              onChange={() => {}}
            />
          ) : (
            <Select
              selectedOption={props.tenantExaminationUnitKbn}
              onChange={({ detail }) =>
                props.onChangeTenantExaminationUnit(detail.selectedOption)
              }
              options={props.tenantExaminationUnitItems}
              selectedAriaLabel="Selected"
            />
          )}
        </FormField>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export const Comment = (props: any) => {
  return (
    <Container>
      <SpaceBetween direction="vertical" size="l">
        <FormField
          label={LABELS.LATEST_COMMENT}
          stretch={true}
          constraintText="2000文字以内"
        >
          <Textarea value={props.actionComment} readOnly />
        </FormField>
        <FormField
          label={
            <SpaceBetween direction="horizontal" size="xs">
              <Box variant="strong">{LABELS.COMMENT}</Box>
              <Box variant="small" color="text-status-error">
                {LABELS.COMMENT_ITEM_MESSAGE}
              </Box>
            </SpaceBetween>
          }
          stretch={true}
          constraintText="2000文字以内"
          errorText={props.commentErrorMsg}
        >
          <Textarea
            onChange={({ detail }) => props.onChangeComment(detail.value)}
            value={props.comment}
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
};
